import { render, staticRenderFns } from "./mating.vue?vue&type=template&id=ede78dbe&scoped=true&"
import script from "./mating.vue?vue&type=script&lang=js&"
export * from "./mating.vue?vue&type=script&lang=js&"
import style0 from "./mating.vue?vue&type=style&index=0&id=ede78dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede78dbe",
  null
  
)

export default component.exports